import { Card, Row, Col } from 'react-bootstrap'
import history from 'utils/history'
import { GlobalOutlined } from '@ant-design/icons'

const ArticleCard = ({
  thumbnailImg, title, url, date, shortDescription,
}) => (
  <Card className="article-card border-0">
    <Row>
      <Col lg={6}>
        {thumbnailImg
          && <img className="img-fluid" src={thumbnailImg} alt="article" />
          }
      </Col>
      <Col lg={6}>
        <div className="mb-3">
          <h3>
            <a href={url}>{title}</a>
          </h3>
          <p>{date}</p>
        </div>
        <div className="text-justify">
          {shortDescription}
          <a href={url}>[Baca Selengkapnya]</a>
        </div>
      </Col>
    </Row>
  </Card>
)
export default ArticleCard
